import React from 'react';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import ImageUpload from 'src/components/sharedComponents/CustomUpload/ImageUpload';
import { Grid } from '@material-ui/core';
import Button from 'src/components/sharedComponents/CustomButtons/Button';
import TextField from '@material-ui/core/TextField';
import Autocomplete, {
  createFilterOptions,
} from '@material-ui/lab/Autocomplete';
import CircularProgress from '@material-ui/core/CircularProgress';
import { makeStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import { a11yProps, TabPanel } from 'src/components/sharedComponents/TapPanel';
import FormParamsTable from 'src/components/insigth/FormParamsTable';

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.paper,
    background: '#fff',
  },
  textField: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
  },
  attributes: {
    position: 'relative',
    display: 'flex',
    '& > *': {
      margin: theme.spacing(1),
    },
  },
  appBar: {
    borderRadius: '5px',
    backgroundColor: '#000',
    color: '#fff',
  },
  center: {
    alignItems: 'center',
    textAlign: '-webkit-center',
  },
}));

const filter = createFilterOptions();

const ValueMapAddVehicle = (props) => {
  const classes = useStyles();
  const {
    open,
    stateEdit,
    newVehicle,
    attributes,
    handleOpenModal,
    handleSelectForm,
    handleCreateCard,
    handleDeleteCard,
    vehiclesBySegment,
    onChangeAddPram,
    handleSaveImage,
  } = props;
  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  return (
    <div>
      <Dialog
        maxWidth="md"
        open={open.open}
        // onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          <strong>{!stateEdit ? 'Editar Vehículo' : 'Nuevo Vehículo'}</strong>
          {!stateEdit ? (
            <div>
              <p>
                <b>Fecha de actualizción: </b>
                {newVehicle.actualizacion}
              </p>
              <p>
                <b>Fecha de creación: </b>
                {newVehicle.creacion}
              </p>
            </div>
          ) : null}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            <Grid container alignItems="center" spacing={2}>
              <Grid item xs={6}>
                <ImageUpload
                  stateEdit={stateEdit}
                  imageDefault={newVehicle.imagen}
                  captureImgBase64={(imagePreviewUrl) => handleSaveImage(imagePreviewUrl)}
                  addButtonProps={{ round: false, size: 'sm' }}
                  changeButtonProps={{
                    round: false,
                    color: 'customAuteco',
                    size: 'sm',
                  }}
                  removeButtonProps={{
                    round: false,
                    color: 'danger',
                    size: 'sm',
                  }}
                />
              </Grid>
              <Grid item xs={6}>
                <div className={classes.center}>
                  <div
                    style={{
                      background: 'black',
                      color: '#fff',
                      padding: ' 10px',
                      borderRadius: '5px',
                    }}
                  >
                    <h4>Seleccione una línea</h4>
                  </div>
                  <br />
                  <Autocomplete
                    value={{
                      LINEA: newVehicle?.linea || '',
                      EMPRESA: newVehicle?.empresa || '',
                      UNIDADES: newVehicle?.unidades || '',
                    }}
                    onChange={(event, vehicle) => {
                      if (typeof vehicle === 'string') {
                        setValue({
                          title: vehicle,
                        });
                      } else if (vehicle && vehicle.inputValue) {
                        // Create a new value from the user input
                        setValue({
                          title: vehicle.inputValue,
                        });
                      } else {
                        handleSelectForm({
                          linea: vehicle?.LINEA || '',
                          empresa: vehicle?.EMPRESA || '',
                          precio: vehicle?.PRECIO || '',
                          promocion: vehicle?.PROMOCION || '',
                          unidades: vehicle?.UNIDADES || '',
                          uuid: vehicle?.UUID || '',
                        });
                      }
                    }}
                    filterOptions={(options, params) => {
                      const filtered = filter(options, params);
                      if (params.inputValue !== '') {
                        filtered.push({
                          LINEA: `Prueba "${params.inputValue}"`,
                          EMPRESA: 'PROTOTIPO',
                          PRECIO: '0.0',
                          PROMOCION: '0.0',
                          UNIDADES: '0',
                          UUID: 'PROTOTIPO',
                        });
                      }

                      return filtered;
                    }}
                    selectOnFocus
                    clearOnBlur
                    handleHomeEndKeys
                    id="fre"
                    options={vehiclesBySegment || []}
                    getOptionLabel={(option) => option?.LINEA || ''}
                    renderOption={(option) => `Linea: ${option?.LINEA || ''} Empresa: ${
                      option?.EMPRESA || ''
                    } Unidades: ${option?.UNIDADES || ''}`}
                    freeSolo
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Línea"
                        variant="standard"
                        InputProps={{
                          ...params.InputProps,
                          endAdornment: (
                            <>
                              {vehiclesBySegment.length === 0 ? (
                                <CircularProgress color="inherit" size={20} />
                              ) : null}
                              {params.InputProps.endAdornment}
                            </>
                          ),
                        }}
                      />
                    )}
                  />
                  <TextField
                    disabled={stateEdit}
                    label="Descripción / Versión"
                    fullWidth
                    variant="standard"
                    value={newVehicle.version}
                    onChange={(e) => handleSelectForm({ version: e.target.value })}
                  />
                  <TextField
                    disabled={stateEdit}
                    fullWidth
                    onChange={(e) => handleSelectForm({ precio: e.target.value })}
                    value={newVehicle.precio}
                    type="number"
                    id="outlined-basic"
                    label="Precio"
                  />
                  <TextField
                    disabled={stateEdit}
                    fullWidth
                    onChange={(e) => handleSelectForm({ promocion: e.target.value })}
                    value={newVehicle.promocion}
                    type="number"
                    id="outlined-basic"
                    label="Promoción"
                  />
                </div>
              </Grid>
              <Grid item xs={12}>
                <div className={classes.root}>
                  <AppBar className={classes.appBar} position="static">
                    <Tabs
                      value={value}
                      onChange={handleChange}
                      aria-label="simple tabs example"
                    >
                      <Tab label="Valoraciones" {...a11yProps(0)} />
                      <Tab label="Características" {...a11yProps(1)} />
                    </Tabs>
                  </AppBar>
                  <TabPanel value={value} index={0}>
                    <FormParamsTable
                      onChangeAddPram={onChangeAddPram}
                      paramUnit="atributo"
                      paramFeature="atributos"
                      arrayParam={newVehicle}
                      stateEdit={stateEdit}
                      attributes={attributes}
                    />
                  </TabPanel>
                  <TabPanel value={value} index={1}>
                    <FormParamsTable
                      onChangeAddPram={onChangeAddPram}
                      paramFeature="caracteristicas"
                      paramUnit="caracteristica"
                      arrayParam={newVehicle}
                      stateEdit={stateEdit}
                    />
                  </TabPanel>
                </div>
              </Grid>
            </Grid>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          {open.isEdit && (
            <Button
              disabled={stateEdit}
              onClick={handleDeleteCard}
              color="danger"
            >
              Eliminar
            </Button>
          )}
          <Button
            disabled={stateEdit}
            onClick={handleCreateCard}
            color="github"
          >
            Guardar
          </Button>
          <Button
            link
            onClick={() => handleOpenModal({ open: false, isEdit: false })}
            color="primary"
            autoFocus
          >
            Cerrar
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default ValueMapAddVehicle;
